function vzBackToTopInit() {
  const backToTopButton =
    ['<a href="#top" class="back-to-top"></a>']
        .join('');
  jQuery('body').append(backToTopButton);

  // Der Button wird ausgeblendet
  jQuery('.back-to-top').hide();

  // Funktion für das Scroll-Verhalten
  jQuery(function() {
    jQuery(window).on('scroll', function() {
      if (jQuery(this).scrollTop() > 300) {
        jQuery('.back-to-top').fadeIn();
      } else {
        jQuery('.back-to-top').fadeOut();
      }
    });

    jQuery('.back-to-top').on('click', function() {
      jQuery('body,html').animate({
        scrollTop: 0,
      }, 800);
      return false;
    });
  });
}
